module.exports = __webpack_public_path__ + "static/img/afsc_icon_3.2b8f5c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/afsc_icon_3.png
// module id = Udp6
// module chunks = 1